import * as Sentry from "@sentry/react";
import { isTelemetryEnabled } from "./env";

export function registerTelemetryContext(properties: Record<string, unknown>) {
  if (!isTelemetryEnabled()) return;

  const tags: Record<string, string> = {};
  const context: Record<string, unknown> = {};

  for (const [key, value] of Object.entries(properties)) {
    if (value === undefined || value === null) continue;
    if (typeof value === "string" || typeof value === "number" || typeof value === "boolean") {
      tags[key] = String(value);
    } else {
      context[key] = value;
    }
  }

  if (Object.keys(tags).length > 0) {
    Sentry.setTags(tags);
  }
  if (Object.keys(context).length > 0) {
    Sentry.setContext("app", context);
  }
}
